import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  AfterViewChecked,
  Optional,
  OnDestroy,
} from '@angular/core';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { EstimatorModalComponent } from './estimator-modal/estimator-modal.component';
import { CommonService } from '../../shareModule/services/common.service';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { CustomerService } from '../../shareModule/services/customer.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { response } from 'express';
import { StoryKachiingComponent } from '../story-kachiing/story-kachiing.component';
import { Location } from '@angular/common';
import { SharedService } from '../../shareModule/services/shared.service';
import { Subject, takeUntil } from 'rxjs';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { PopUpService } from 'src/app/popupservice.service';

@Component({
  selector: 'app-show-bookings',
  templateUrl: './show-bookings.component.html',
  styleUrls: ['./show-bookings.component.scss'],
})
export class ShowBookingsComponent implements OnInit, OnDestroy {
  @Input() set selectedMapCategory(value) {
    this._selectedMapCategory = value;
    this.checkEstimator()
  }

  @Output() openEstimatorModal = new EventEmitter<void>();

  get selectedMapCategory() {
    return this._selectedMapCategory;
  }

  _selectedMapCategory: any = null;



  @Input() isSelectSubCat: boolean = false;
  @Input() currentSelectedTypes: any[] = [];
  @Input() mapCategories: any[] = [];
  @Input() locationCondition: any = {};
  @Input() filter: string = '';

  @Output() productLocationClicked = new EventEmitter<any>();
  @Output() productViewClicked = new EventEmitter<any>();

  public imgUrl = environment.ImageUrl;
  public bookingResultProducts = [];
  public currentCategoryBookingQuestions = [];
  public alreadyAnsweredQuestions?: Set<string>;
  public areThereBookingQuestion = false;
  public currentCategoryTagList: string[] = [];
  public bizTags: string[] = [];
  public userTags: string[] = [];
  public newTagText = '';
  public selectedTags = new Set<string>();
  public bookingSwiper = null;
  public hasEstimator = false
  public didEstimatorOpen = null;

  public variableGroups = [];

  public currentCategoryBookingImageInfo: any = {};
  public phoneOfUSer = '';
  public postalCodeOfUser = '';
  public thankYouText = '';
  public bookingSteps: Array<{ title: string; description: string }> = [];

  private destroy$ = new Subject<void>();
  private estimatorModalRef: NgbModalRef | null = null;
  private estimatorBottomSheetRef: MatBottomSheetRef<EstimatorModalComponent> | null =
    null;

  constructor(
    public modal: NgbActiveModal,
    public commonService: CommonService,
    private auth: AuthServiceService,
    private customerService: CustomerService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private local: LocalServiceService,
    private modalService: NgbModal,
    private location: Location,
    private sharedService: SharedService,
    private roleService: RoleService,
    private popup: PopUpService,

    @Optional()
    private activeModal: NgbActiveModal,
  ) { }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.checkEstimator()
    this.roleService.rolesSubject
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        this.isAdmin = response?.userType?.includes('ADMIN');
        this.cdr.detectChanges();
      });
    this._getBookingMoreInfos(
      this.currentSelectedTypes?.length
        ? this.currentSelectedTypes[0]
        : this.selectedMapCategory,
    );

    this._fetchAnsweredQuestions();

    // Construct filter if not provided
    if (!this.filter) {
      this.filter = this.getFilter();
    }
  }

  private getFilter(): string {
    let filter = 'map';
    if (this.selectedMapCategory?.id) {
      filter += `-${this.selectedMapCategory.id}`;
    }
    if (this.currentSelectedTypes?.length) {
      filter += `-${this.currentSelectedTypes[0]?.id}`;
    }
    return filter;
  }

  private checkEstimator() {
    const { id, isType } = this.getCurrentCategoryOrTypeId();
    this.auth.getBookingVariableSuperGroupsByCategory(id, isType).subscribe({
      next: (res) => {
        this.hasEstimator = res.body?.length;
      },
    });
  }

  openStore(): void {
    // Close the current modal first
    this.modal.close();

    // Update URL to include story=1 parameter (remove booking=1 if present)
    this._updateUrlWithQueryParam('booking', null);
    this._updateUrlWithQueryParam('story', '1');

    // Open story-kachiing modal
    const modalRef = this.modalService.open(StoryKachiingComponent, {
      size: 'md',
      centered: true,
      backdrop: true,
      keyboard: true,
      windowClass: 'story_modal',
    });

    // Pass filter and category data to the modal component
    const componentInstance =
      modalRef.componentInstance as StoryKachiingComponent;
    componentInstance.filter = this.filter || this.getFilter();
    componentInstance.isBookingNow = true;
    componentInstance.selectedMapCategory = this.selectedMapCategory;
    componentInstance.currentSelectedTypes = this.currentSelectedTypes;
    componentInstance.openShowBookingsModal.subscribe(() => {
      // Handle booking modal opening if needed
      modalRef.close();
    });

    // Remove query param when modal closes
    modalRef.hidden.subscribe(() => {
      this._updateUrlWithQueryParam('story', null);
    });
  }

  private _updateUrlWithQueryParam(key: string, value: string | null): void {
    if (!this.sharedService.isBrowser()) {
      return;
    }

    const url = new URL(window.location.href);

    if (value === null) {
      // Remove the query parameter
      url.searchParams.delete(key);
    } else {
      // Add or update the query parameter
      url.searchParams.set(key, value);
    }

    // Build the new URL preserving existing query params
    const newQueryString = url.searchParams.toString();
    const basePath = window.location.pathname;
    const newUrl = newQueryString ? basePath + '?' + newQueryString : basePath;
    this.location.replaceState(newUrl);
  }

  // private _initializeWithPassedData(): void {
  //   // Initialize with passed data
  //   if (
  //     this.currentCategoryBookingImageInfo?.url == null ||
  //     this.currentCategoryBookingImageInfo?.url == '' ||
  //     !this.currentCategoryBookingImageInfo
  //   ) {
  //     this.currentBookingPage = 1;
  //   }
  //   this.cdr.detectChanges();
  // }

  private _fetchAnsweredQuestions() {
    this.auth
      .getMyMapQuestionResponse(this.currentSelectedTypes?.length)
      .subscribe({
        next: (data) => {
          this.alreadyAnsweredQuestions = new Set(
            data.body.map((response) => {
              return response.question;
            }),
          );
          this.areThereBookingQuestion =
            this.currentCategoryBookingQuestions.some((qn) => {
              return (
                !qn.isTag &&
                this.alreadyAnsweredQuestions &&
                !this.alreadyAnsweredQuestions?.has(
                  qn?.question ?? qn?.questionText,
                )
              );
            });
          this.cdr.detectChanges();
        },
      });
  }

  public bookingTagClicked(event, tag) {
    event.stopPropagation();
    event.preventDefault();
    if (this.selectedTags.has(tag)) {
      this.selectedTags.delete(tag);
    } else {
      this.selectedTags.add(tag);
    }
  }

  public trackByTag(index: number, tag: string): string {
    return tag;
  }

  // trackBy for questions - helps preserve input focus & performance
  trackByQuestion(index: number, qn: any): any {
    return qn?.id ?? qn?.question ?? qn?.questionText ?? index;
  }

  // trackBy for choices - handles string or object choices
  trackByChoice(index: number, choice: any): any {
    if (choice && typeof choice === 'object') {
      return choice.id ?? index;
    }
    // for primitive choices, return the value (stable if values don't duplicate)
    return choice ?? index;
  }

  public goToNextPage() {
    if (
      (this.activePageIndex == 1 && this.totalPagesCount == 4) ||
      (this.activePageIndex == 0 && this.totalPagesCount == 3)
    ) {
      this.fetchProductsBySelectedTag();
    }

    if (
      (this.activePageIndex == 2 && this.totalPagesCount == 4) ||
      (this.activePageIndex == 1 && this.totalPagesCount == 3)
    ) {
      if (this.phoneOfUSer == '' || this.phoneOfUSer == null) {
        return this.local.alertInfo({
          title: 'Submit contact number to continue',
          message: '',
        });
      }

      if (this.phoneOfUSer.toString().length != 8) {
        console.log(this.phoneOfUSer.toString().length);
        return this.local.alertInfo({
          title: 'Please enter a valid phone number',
          message: '',
        });
      }

      this.submitBookingResponses();
    }

    this.bookingSwiper?.slideTo(this.activePageIndex + 1);
  }

  public get activePageIndex() {
    return this.bookingSwiper?.activeIndex ?? 0;
  }

  public get totalPagesCount() {
    return this.bookingSwiper?.slides?.length ?? 0;
  }

  public get showNext() {
    return this.activePageIndex < this.totalPagesCount - 1; // this.totalPagesCount == 4 && this.activePageIndex  < 3 || this.totalPagesCount == 3 && this.activePageIndex < 2;
  }

  public get showClose() {
    return this.activePageIndex + 1 == this.totalPagesCount;
  }

  public fetchProductsBySelectedTag() {
    this.customerService
      .getMemberShopProductList({
        limit: 10,
        basedProduct: 'all',
        containsTags: Array.from(this.selectedTags).map(
          (val) => String(val).charAt(0).toUpperCase() + String(val).slice(1),
        ),
        ...this.getLocationCondition(),
        categoryId: this.isSelectSubCat
          ? this.selectedMapCategory?.categorieChildId
          : this.selectedMapCategory?.id,
      })
      .subscribe({
        next: (data) => {
          // this.bookingSwiper.slideTo(3);
          this.bookingResultProducts = this._sortProductsByInfo(data.body.data);
        },
      });
  }

  private getCurrentCategoryOrTypeId() {
    let selectedCategoryId = this.selectedMapCategory?.id;

    if (this.isSelectSubCat) {
      selectedCategoryId = this.selectedMapCategory?.categorieChildId;
    }

    const id = this.currentSelectedTypes?.length
      ? this.currentSelectedTypes[0]?.id
      : selectedCategoryId;
    const isType = !!this.currentSelectedTypes?.length;
    return { id, isType };
  }
  public customUserId = (Math.random() * 100000).toFixed();


  submitBookingResponses() {
    try {
      const { id, isType } = this.getCurrentCategoryOrTypeId();

      this.auth
        .bulkSaveMapQuestionResponses(
          id,
          [
            ...this.currentCategoryBookingQuestions,
            {
              questionText: 'Phone number of booker:',
              answer: this.phoneOfUSer + '',
            },
            {
              questionText: 'Postal code of booker:',
              answer: this.postalCodeOfUser + '',
            },
            // ...this.getVariablesResponse(),
          ],
          isType ? 'type' : 'category',
          this.customUserId,
        )
        .subscribe({
          next: () => {
            this.toastr.success('Saved');
            this._fetchAnsweredQuestions();
            this.cdr.detectChanges();
          },
          error: (error) => {
            this.toastr.error(error.error.message);
          },
        });
    } catch (e) {
      console.error(e);
    }
  }

  private getLocationCondition() {
    return this.locationCondition;
  }

  private _sortProductsByInfo(productsList: any[]) {
    return productsList.sort((a, b) => {
      const infoB = this.commonService.getProductInformationScore(b);
      const infoA = this.commonService.getProductInformationScore(a);
      return infoB - infoA;
    });
  }

  public closeBookingModal() {
    this.modal.close();
  }

  public openSelectBookingImage() {
    // This method should be implemented based on requirements
    console.log('Open select booking image');
  }

  public showProductLocationOnMap(product: any) {
    this.productLocationClicked.emit(product);
  }

  public viewProduct(product: any) {
    this.productViewClicked.emit(product);
  }

  public isAdmin = false;
  public openEstimatorPanel() {

    this.openEstimatorModal.emit();
  }

  private _getBookingMoreInfos(selectedCategory) {
    // Separate Biz Tags and User Tags
    this.bizTags = selectedCategory?.bookingMoreInfos?.tagChoices ?? [];
    this.userTags = selectedCategory?.bookingMoreInfos?.tagUserChoices ?? [];

    // Keep combined list for backward compatibility
    this.currentCategoryTagList = [...this.bizTags, ...this.userTags];
    this.currentCategoryBookingImageInfo = (
      selectedCategory?.bookingMoreInfos?.uploadedImages as any[]
    )?.at(0);
    this.thankYouText = selectedCategory?.bookingMoreInfos?.thankYouText;
    this.bookingSteps = selectedCategory?.bookingMoreInfos?.steps ?? [];

    if (!this.currentCategoryBookingImageInfo) {
      this.currentCategoryBookingImageInfo = {
        url: '',
        imageFile: null,
        caption: '',
        convertedFileUrl: null,
      };
    }

    try {
      this.currentCategoryBookingQuestions = JSON.parse(
        selectedCategory.mapQuestions ?? '[]',
      );
    } catch (e) { }

    this.cdr.detectChanges();
  }

  public markEstimatorForUpdate() {
    this.cdr.detectChanges();
  }

  transformHtml(value: string | null): string {
    if (!value) return '';
    const text = value.replace(/<[^>]*>/g, '').trim(); // remove HTML tags
    return text;
  }
}
